import React from 'react';

const Circle = props => (
  <svg height={6} width={6} {...props}>
    <circle cx="3" cy="3" r="2" fill="black" />
  </svg>
);

export default Circle;
